"use client";

import { c as _c } from "react/compiler-runtime";
import { Vote } from "lucide-react";
import type { PollVote } from "./types";
const dateFormatter = new Intl.DateTimeFormat(undefined, {
  month: "short",
  day: "numeric"
});
interface PollCardProps {
  vote: PollVote;
  labels: Record<string, string>;
}
export default function PollCard(t0) {
  const $ = _c(26);
  const {
    vote,
    labels
  } = t0;
  const title = vote.pollModel?.title || vote.pollId;
  let t1;
  if ($[0] !== vote.optionModel?.title || $[1] !== vote.optionsModels) {
    t1 = vote.optionsModels?.length > 0 ? vote.optionsModels.map(_temp).join(", ") : vote.optionModel?.title || "\u2014";
    $[0] = vote.optionModel?.title;
    $[1] = vote.optionsModels;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const chosenOptions = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Vote className="h-2.5 w-2.5" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = labels.gameTypePoll || "Poll";
  let t4;
  if ($[4] !== t3) {
    t4 = <span className="inline-flex items-center gap-1 rounded-full bg-blue-500/10 px-1.5 py-0.5 text-[10px] font-semibold text-blue-600">{t2}{t3}</span>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== vote.createdAt) {
    t5 = dateFormatter.format(new Date(vote.createdAt));
    $[6] = vote.createdAt;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <span className="text-[10px] text-muted-foreground">{t5}</span>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t6) {
    t7 = <div className="flex items-center justify-between">{t4}{t6}</div>;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== title) {
    t8 = <p className="text-sm font-medium text-foreground line-clamp-2">{title}</p>;
    $[13] = title;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const t9 = labels.yourVote || "Your vote";
  let t10;
  if ($[15] !== t9) {
    t10 = <span className="text-muted-foreground truncate">{t9}</span>;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== chosenOptions) {
    t11 = <span className="shrink-0 rounded-full bg-primary/10 px-2 py-0.5 font-semibold text-primary truncate max-w-[60%]">{chosenOptions}</span>;
    $[17] = chosenOptions;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t10 || $[20] !== t11) {
    t12 = <div className="flex items-center justify-between gap-2 text-xs">{t10}{t11}</div>;
    $[19] = t10;
    $[20] = t11;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t12 || $[23] !== t7 || $[24] !== t8) {
    t13 = <div className="flex flex-col gap-2 rounded-lg bg-card p-3">{t7}{t8}{t12}</div>;
    $[22] = t12;
    $[23] = t7;
    $[24] = t8;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  return t13;
}
function _temp(o) {
  return o.title;
}